import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Input,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  Table,
  PaginationLink,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Label,
  FormGroup,
  Badge,
  Form
} from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaBarcode, FaCalendarAlt, FaEnvelope, FaHistory, FaImage, FaList, FaMapMarkerAlt, FaMinus, FaMoneyBillWave, FaPlus, FaPrint, FaReceipt, FaSearch, FaShoppingCart, FaStore, FaTh, FaTimes, FaTrash, FaUser, FaUserTag, FaWhatsapp } from 'react-icons/fa'; // Import trash icon
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useTranslation } from "react-i18next";
import { FaSave, FaTrashAlt } from 'react-icons/fa';
import emptyCart from "../../assets/images/empty-cart.png";
import { productActions } from "../../sagas/productSlice";
import { useDispatch, useSelector } from "react-redux";
import { debounce, set } from "lodash";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { supplierActions } from "../../sagas/supplierSlice";
import { purchaseActions } from "../../sagas/purchaseSlice";
import config from "../../helpers/config";
import { PURCHASES_HISTORY_PAGE } from "../../routes/routeConstants";
import { formatPrice } from "../../helpers/utility";

const BuyForm = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [modal, setModal] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [amountPaid, setAmountPaid] = useState(0);
  const cart = useSelector(state => state.purchases?.cart || []);
  const isLoading = useSelector(state => state.purchases?.isLoading);
  const highlightedItem = useSelector(state => state.purchases?.highlightedItem);
  const [cartPage, setCartPage] = useState(1);
  const totalAmount = useSelector(state => state.purchases?.totalAmountHt || 0);
  const [chooseProductModal, setChooseProductModal] = useState(false);
  const [modalSearchTerm, setModalSearchTerm] = useState(''); // Separate state for modal search
  const quantityInputRef = useRef(null);

  const [newBuy, setNewBuy] = useState({
    totalAmount: 0,
    purchaseStatus: null,
    supplierId: 0,
    code: null,
  })

  const [clearCartModal, setClearCartModal] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const fullName = useSelector(state => state.auth.fullName);
  const { company } = useSelector(state => state.auth);
  // Add inside component
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    loading,
    totalPages,
    totalElements,
    pageNumber,
    pageSize,
    error,
  } = useSelector((state) => state.products);
  const products = useSelector((state) => state.products.products);
  const [displayMode, setDisplayMode] = useState('card'); // or 'card'

  const {
    suppliers,
    loading: suppliersLoading,
    totalPages: suppliersTotalPages,
    totalElements: suppliersTotalElements,
    pageNumber: suppliersPageNumber,
    pageSize: suppliersPageSize,
    error: suppliersError,
  } = useSelector((state) => state.suppliers);
  const [criteria, setSearchCriteria] = useState({ query: '' });
  const searchInputRef = useRef(null);
  const [product, setProduct] = useState({
    description: '',
    buyingPrice: '',
    userPrice: '',
    supplierId: '',
    barcode: '',
    stock: '',
  });
  const [newSupplierModal, setNewSupplierModal] = useState(false);
  const [newSupplier, setNewSupplier] = useState({ name: '', contact: '', address: '' });
  const [supplierModal, setSupplierModal] = useState(false);
  const [suppliersPagination, setSuppliersPagination] = useState({ currentPage: 1, pageSize: 10 });
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedNewSupplier, setSelectedNewSupplier] = useState(null);
  const [purpose, setPurpose] = useState('purchase');
  const [lastAddedItemId, setLastAddedItemId] = useState(null);
  const newItemRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [searchSupplierQuery, setSearchSupplierQuery] = useState('');
  const [isSupplierSearching, setIsSupplierSearching] = useState(false);

  useEffect(() => {
    if (lastAddedItemId) {
      newItemRef.current?.focus();
    }
  }, [lastAddedItemId]);

  useEffect(() => {
    // Auto focus on mount
    searchInputRef.current?.focus();

    // Add keyboard shortcut
    const handleKeyDown = (e) => {
      if (e.key === 'F2') {
        e.preventDefault();
        searchInputRef.current?.focus();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  console.log(cart)
  const toggleClearCartModal = () => setClearCartModal(!clearCartModal);

  // Add new state

  const currentCartItems = cart;

  const { t } = useTranslation();



  useEffect(() => {
    let payload = {
      criteria,
      page: currentPage,
      size: pageSize,
    };

    dispatch(productActions.search(payload));
  }, [currentPage]);

  useEffect(() => {
    if (isSearching && searchTerm.length >= 3) {
      const searchLower = searchTerm.toLowerCase();
      
      // Check for exact barcode match
      const matchedItems = products?.filter(p =>
        p.barcode?.toLowerCase().includes(searchLower) ||
        p.code?.toLowerCase().includes(searchLower) ||
        p.description?.toLowerCase().includes(searchLower)
      );


      if (matchedItems.length === 1) {
        // Add to cart directly
        handleAddToCart(matchedItems[0]);
        if (searchTerm.length > 8) { // Assuming barcode length is 13
          setSearchTerm('');
          //searchInputRef.current?.focus();
        }
      } else if (matchedItems.length > 1 && searchTerm.length >= 3) {
        // Show modal with search results
        //setSearchResults();
        setIsModalOpen(true);
      } else {
        //setSearchResults([]);
      }
    }

  }, [products]);


  const handleAddToCart = (product) => {
    setIsSearching(false)
    const existingItem = cart.find((item) => item.id === product.id);
    if (existingItem) {
      // If item is already in cart, focus & highlight it
      setLastAddedItemId(existingItem.id);
      
    } else {
      dispatch(purchaseActions.addToCart(product));
      setLastAddedItemId(product.id); // will be used to set focus
    }
  };

  const toggleChooseProductModal = () => {
    setChooseProductModal(!chooseProductModal);
    setModalSearchTerm('');
    debouncedModalSearch('');
  };

  useEffect(() => {
    if (highlightedItem && quantityInputRef.current) {
      quantityInputRef.current.focus();
    } else if (!isLoading) {
      searchInputRef.current.focus();
    }
  }, [highlightedItem, isLoading]);


  const handleUpdateQuantity = useCallback((productId, quantity, price, userPrice) => {
    dispatch(purchaseActions.updateQuantity({ id: productId, quantity, price, userPrice }));
  }, [dispatch]);

  // Debounced search function for the modal search input
  const debouncedModalSearch = useCallback(
    debounce((query) => {
      setIsSearching(true);
      dispatch(productActions.search({
        criteria: { query },
        page: 1,
        size: pageSize,
        onSuccess: () => setIsSearching(false)
      }));
    }, 500),
    [modalSearchTerm]
  );

  // Handle modal search input change
  const handleModalSearchChange = (e) => {
    const value = e.target.value;
    setModalSearchTerm(value);
    debouncedModalSearch(value);
  };

  const handleRemoveFromCart = useCallback((productId) => {
    dispatch(purchaseActions.removeFromCart(productId));

  }, [cart, dispatch]);

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((term) => {
      dispatch(productActions.search({
        criteria: {
          query: term,
        },
        page: 1,
        size: 10,
      }));
    }, 500), // Adjust the debounce delay as needed
    []
  );

  const handleSupplierPageChange = (page) => {
    setSuppliersPagination(prev => ({ ...prev, currentPage: page }));
    dispatch(supplierActions.search({
      query: searchSupplierQuery,
      page,
      size: suppliersPagination.pageSize
    }));
  };

  const handleSupplierSearchChange = (e) => {
    const value = e.target.value;
    setSearchSupplierQuery(value);
    debouncedSupplierSearch(value);
  };

  const handleNewSupplierSubmit = () => {
    dispatch(supplierActions.addSupplier({
      ...newSupplier,
      onSuccess: () => {
        setNewSupplierModal(false);
        dispatch(supplierActions.search({ page: 0, size: 10 }));
        Swal.fire({
          icon: 'success',
          title: t('supplier.addSuccess'),
          timer: 1500
        });
      }
    }));
  };
  const debouncedSupplierSearch = useCallback(
    debounce((query) => {
      setIsSupplierSearching(true);
      dispatch(supplierActions.search({
        query,
        page: 0,
        size: 8,
        onSuccess: () => setIsSupplierSearching(false)
      }));
    }, 1500), // Wait 500ms after last keystroke
    []
  );
  const handleSupplierSelect = (supplier) => {
    if (purpose === 'purchase') {
      setSelectedSupplier(supplier);
      product.supplierId = supplier.id;
    } else {
      setSelectedNewSupplier(supplier);
    }
    setSupplierModal(false);
  };
  // Handle search input change
  const handleSearchChange = (e) => {
    const term = e.target.value;
    setIsSearching(true);
    setSearchTerm(term);

    if (/^\d{8,13}$/.test(term)) {
      // If the term is a valid barcode (8 to 13 digits), assume barcode reader
      debouncedSearch(term);
    } else {
      // Otherwise, assume keyboard input
      debouncedSearch(term);
    }


  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleClearCart = () => {
    Swal.fire({
      title: t('cart.clearConfirmMessage'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(purchaseActions.clearCart());
        setCartPage(1); // Reset cart page

      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      // Add product data
      formData.append('description', e.target.description.value);
      formData.append('barcode', e.target.barcode.value);
      formData.append('userPrice', parseFloat(e.target.price.value));
      formData.append('buyingPrice', parseFloat(e.target.buyingPrice.value));
      formData.append('stock', parseInt(e.target.stock.value));
      formData.append('supplierId', selectedNewSupplier ? selectedNewSupplier.id : 0);

      // Create product
      dispatch(productActions.addProduct({
        product: formData,
        onSuccess: () => {
          toggleProductModal();
          // Reset form
          e.target.reset();
          Swal.fire({
            icon: 'success',
            title: t('product.addSuccess'),
            showConfirmButton: false,
            timer: 1500
          });
          setSelectedNewSupplier(null);
          // Refresh list
          let payload = {
            criteria: {
              query: searchTerm,
              supplierId: selectedSupplier ? selectedSupplier.id : null
            },
            page: currentPage,
            size: pageSize,
          };
          dispatch(productActions.search(payload));
        },
        onError: (error) => {
          console.error('Create product error:', error);
        }
      }));

    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: t('common.error'),
        text: error.message,
        confirmButtonColor: '#dc3545'
      });
    }
  };

  const handleCloseSupplierModal = () => {
    setSupplierModal(false);
    setSearchSupplierQuery('');
  };

  // Create Sale
  const [clientModal, setClientModal] = useState(false);
  const [productModal, setProductModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const resetForm = () => {
    setProduct({
      name: '',
      price: '',
      barcode: '',
      priceOverride: false,
    });

  };
  const toggleClientModal = () => setClientModal(!clientModal);
  const toggleProductModal = () => setProductModal(!productModal);

  const handleOpenSupplierModal = (flag) => {
    dispatch(supplierActions.search({
      query: '',
      page: 0,
      size: 10
    }));
    setSupplierModal(true);
    setPurpose(flag);

  };
  console.log('selectedSupplier', selectedSupplier);

  const handleCreateSale = () => {
    if (cart.length === 0) return;

    if (!selectedSupplier) {
      Swal.fire({
        icon: 'warning',
        title: t('stock.selectSupplier'),
        text: t('stock.selectSupplierMessage'),
        confirmButtonText: t('common.ok')
      });
      return;
    }

    // Check if any item has a price less than or equal to 0
    const hasInvalidPrice = cart.some(item => item.price <= 0);
    if (hasInvalidPrice) {
      Swal.fire({
        icon: 'warning',
        title: t('buy.invalidPriceTitle'),
        text: t('buy.invalidPriceMessage'),
        confirmButtonText: t('common.ok')
      });
      return;
    }

    Swal.fire({
      title: t('buy.confirmTitle'),
      html: `
      <div class="text-start p-3">
          <p class="mb-3">${t('sale.successMessage')}</p>
          <table class="table table-borderless mb-0">
          <tr>
            <td>${t('sale.amountPaid')}:</td>
            <td class="text-end"><strong>${formatPrice(totalAmount)}</strong></td>
          </tr>
          <tr>
            <td>${t('stock.supplier')}:</td>
            <td class="text-end"><strong>${selectedSupplier ? selectedSupplier.description : ''}</strong></td>
          </tr>
          </table>
        </div>
      `,
      preConfirm: () => {

        return {};
      },
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#6c757d',
      confirmButtonText: t('common.confirm'),
      cancelButtonText: t('common.cancel')
    }).then((result) => {
      if (result.isConfirmed) {
        const updatedBuy = {
          ...newBuy,
          supplierId: selectedSupplier ? selectedSupplier.id : 0,
          supplierName: selectedSupplier ? selectedSupplier.description : '',
          totalAmount: totalAmount,
        };
        dispatch(purchaseActions.createPurchase({
          data: {
            ...updatedBuy,
            lines: [...cart],
          },
          onSuccess: () => {
            Swal.fire({
              icon: 'success',
              title: t('buy.successTitle'),
              timer: 3000,
              showConfirmButton: false
            });
            dispatch(purchaseActions.clearCart());
            setSelectedSupplier(null);
          }
        }));
      }
    });
  };

  const DisplayToggle = () => (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div className="btn-group">
        <Button
          color={displayMode === 'table' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('table')}
          size="sm"
        >
          <FaList className="me-1" /> {t('common.table')}
        </Button>
        <Button
          color={displayMode === 'card' ? 'primary' : 'light'}
          onClick={() => setDisplayMode('card')}
          size="sm"
        >
          <FaTh className="me-1" /> {t('common.cards')}
        </Button>
      </div>

      <div className="d-flex align-items-center gap-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>

        <div className="d-flex align-items-center gap-2">
          <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
            <FaAngleDoubleLeft />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
            <FaAngleLeft />
          </Button>

          <span className="mx-2">
            {currentPage} / {totalPages}
          </span>

          <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
            <FaAngleRight />
          </Button>
          <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
            <FaAngleDoubleRight />
          </Button>
        </div>
      </div>
    </div>
  );


  const TableView = () => (
    <>
      <div className="cart-container" style={{
        height: '400px',
        overflowY: 'auto'
      }}>
        <Table bordered hover>
          <thead>
            <tr>
              <th>{t('product.code')}</th>
              <th>{t('product.description')}</th>
              <th>{t('product.salePrice')}</th>
              <th>{t('product.buyingPrice')}</th>
            </tr>
          </thead>
          <tbody>
            {!products || products.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  <div className="text-muted">
                    {t('product.noProducts')}
                  </div>
                </td>
              </tr>
            ) : (products.map((product) => (
              <tr key={product.id} onClick={() => handleAddToCart(product)}>
                <td>{product.barcode}</td>
                <td>
                  {product.description.length > 10 ? product.description.substring(0, 10) + '...' : product.description}
                </td>
                <td className="text-end">{formatPrice(product.userPrice, false)}</td>
                <td className="align-middle text-end">{formatPrice(product.buyingPrice, false)}</td>

              </tr>
            ))
            )}
          </tbody>
        </Table>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <small className="text-muted">
          {t('product.showing', {
            start: (currentPage - 1) * pageSize + 1,
            end: Math.min(currentPage * pageSize, totalElements),
            total: totalElements,
            currentPage: currentPage,
            totalPages: totalPages
          })}
        </small>
      </div>
    </>
  );

  const CardView = () => (
    <div className="card-container" style={{ height: '400px', overflowY: 'auto' }}>
      <Row xs={2} md={3} lg={3} className="g-3">
        {(!products || products.length === 0) && (
          <Col xs={12} className="text-center py-4 ">
            {t('product.noProducts')}
          </Col>
        )}
        {products.map(product => (
          <Col key={product.id}>
            <Card className="product-card rounded border shadow-sm" onClick={() => handleAddToCart(product)}>
              <div className="card-image-container">
                {product.imageServerUrl ? (
                  <img
                    src={`${config.baseURL}${product.imageServerUrl}`}
                    alt={product.description}
                    className="card-img-top rounded-top"
                  />
                ) : (
                  <div className="bg-placeholder rounded-top d-flex align-items-center justify-content-center">
                    <FaImage size={32} className="text-muted" />
                  </div>
                )}
              </div>
              <CardBody className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start">
                  <h6 className="product-title mb-2">
                    {product.description.length > 10 ? product.description.substring(0, 10) + '...' : product.description}
                  </h6>
                </div>
                <p className="product-price">{formatPrice(product.userPrice)}</p>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );

  const handleProductButtonClick = () => {
    toggleProductModal();
  };

  const generatePDF = () => {
    const element = document.getElementById('receipt-content');
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.autoPrint();
      window.open(pdf.output('bloburl'), '_blank');
    });
  };

  const handleClearSupplierFilter = () => {
    setSelectedSupplier(null);
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      dispatch(productActions.search({
        criteria: { searchTerm },
        page: 1,
        size: pageSize
      }));
    }
  };

  const handleCheckboxChange = (productId, checked) => {
    if (checked) {
      setSelectedProductIds((prev) => [...prev, productId]);
    } else {
      setSelectedProductIds((prev) => prev.filter((id) => id !== productId));
    }
  };

  const handleAddSelectedProducts = () => {
    // Find the selected products from searchResults
    const chosen = products.filter((p) => selectedProductIds.includes(p.id));
    // Loop through or map them, call handleAddProduct(p) for each
    const addProductWithDelay = async (product) => {
      await new Promise((resolve) => setTimeout(resolve, 100)); // 100ms delay
      handleAddToCart(product);
    };

    const addProductsSequentially = async () => {
      for (const prod of chosen) {
        await addProductWithDelay(prod);
      }
    };

    addProductsSequentially();
    setIsModalOpen(false);
    setSearchTerm('');
    setSelectedProductIds([]);
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12} className="ps-4 border-start">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="position-relative flex-grow-1 me-3">
              <Input
                innerRef={searchInputRef}
                type="text"
                placeholder={t('product.searchFocusHint')}
                value={searchTerm}
                onKeyDown={handleSearchKeyDown}
                onChange={handleSearchChange}
                className={`ps-4 pe-5 ${isSearching ? 'searching' : ''}`}
                title={t('product.searchShortcut')}
              />
              <FaSearch
                style={{
                  position: 'absolute',
                  left: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#adb5bd'
                }}
                size={14}
              />
              <FaBarcode
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: '#adb5bd'
                }}
                size={20}
                title={t('product.scanHint')}
              />
            </div>
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center me-2"
              onClick={toggleChooseProductModal}
            >
              <FaPlus className="me-2" />
              {t('product.chooseProduct')}
            </Button>
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center me-2"
              onClick={() => handleOpenSupplierModal('purchase')}
            >
              <FaUserTag className="me-2" />
              {t('stock.selectSupplier')}
            </Button>
            {selectedSupplier && (
              <div className="d-flex align-items-center me-2">
                <FaUserTag className="me-1" />
                <span>{selectedSupplier.description}</span>
                <Button
                  color="link"
                  size="sm"
                  className="ms-1 p-0"
                  onClick={handleClearSupplierFilter}
                >
                  <FaTimes size={12} />
                </Button>
              </div>
            )}
            <Button
              color="primary"
              size="sm"
              className="d-flex align-items-center"
              onClick={() => navigate(PURCHASES_HISTORY_PAGE)}
              title={t('buy.viewHistory')}
            >
              <FaHistory className="me-2" />
              {t('buy.viewHistory')}
            </Button>
          </div>
          <Card>
            <div className="card-header bg-light d-flex justify-content-between align-items-center py-3">
              <div className="d-flex align-items-center">
                <div className="position-relative me-2">
                  <FaShoppingCart size={18} className="text-primary" />
                  {cart.length > 0 && (
                    <Badge
                      color="danger"
                      pill
                      className="position-absolute d-flex align-items-center justify-content-center"
                      style={{
                        top: '-6px',
                        right: '-10px',
                        fontSize: '0.65rem',
                        width: '16px',
                        height: '16px',
                        padding: 0
                      }}
                    >
                      {cart.reduce((total, item) => total + item.quantity, 0)}
                    </Badge>
                  )}
                </div>
                <h6 className="mb-0 fw-bold">{t('cart.title')}</h6>
              </div>

              {cart.length > 0 && (
                <Button
                  color="danger"
                  size="sm"
                  onClick={handleClearCart}
                >
                  <FaTrash size={12} />
                </Button>
              )}
            </div>
            <CardBody className="p-0">

              {cart.length === 0 ? (
                <div className="text-center py-5">
                  <img
                    src={emptyCart}
                    alt="Empty Cart"
                    style={{
                      width: '150px',
                      opacity: '0.5',
                      marginBottom: '1rem'
                    }}
                  />
                  <p className="text-muted">{t('cart.empty')}</p>
                </div>
              ) : (
                <>
                  <Card className="mb-3">
                    <CardBody className="p-0">
                      <div style={{
                        height: '400px',
                        overflowY: 'auto'
                      }}>
                        <Table hover responsive className="table-cart">
                          <thead className="bg-light position-sticky top-0" style={{ zIndex: 1 }}>
                            <tr>
                              <th >{t('product.code')}</th>
                              <th >{t('product.description')}</th>
                              <th>{t('product.buyingPrice')}</th>
                              <th>{t('product.salePrice')}</th>
                              <th>{t('product.stockActuel')}</th>
                              <th>{t('cart.quantity')}</th>
                              <th>{t('cart.subtotal')}</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentCartItems.map((item) => (
                              <tr key={item.id}
                                className={`align-middle ${item.id === lastAddedItemId ? 'table-warning' : ''}`}

                              >
                                <td style={{ maxWidth: '200px', fontSize: '0.9rem' }}>
                                  {item.barcode}

                                </td>
                                <td >
                                  {item.description.length > 30 ? item.description.substring(0, 30) + '...' : item.description}

                                </td>
                                <td>
                                  <Input
                                    type="number"
                                    step="0.1"
                                    value={item.price}
                                    innerRef={highlightedItem === item.id ? quantityInputRef : null}
                                    onFocus={(e) => e.target.select()} // Select the field content on focus
                                    onChange={(e) => handleUpdateQuantity(item.id, item.quantity, e.target.value, item.userPrice)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        searchInputRef.current?.focus();
                                      }
                                    }}
                                    className="form-control form-control-sm text-center"
                                    style={{ width: '90px' }}
                                  />
                                </td>
                                <td>
                                  <Input
                                    type="number"
                                    step="0.1"
                                    value={item.userPrice}
                                    onChange={(e) => handleUpdateQuantity(item.id, item.quantity, item.price, e.target.value)}
                                    className="form-control form-control-sm text-center"
                                    style={{ width: '90px' }}
                                    onFocus={(e) => e.target.select()} // Select the field content on focus
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        searchInputRef.current?.focus();
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  {item.stockActuel !== undefined ? item.stockActuel : 'N/A'}
                                </td>
                                <td >
                                  <Input
                                    type="number"
                                    step="1"
                                    value={item.quantity}
                                    onFocus={(e) => e.target.select()} // Select the field content on focus
                                    onChange={(e) => handleUpdateQuantity(item.id, e.target.value, item.price, item.userPrice)}
                                    className="form-control form-control-sm text-center"
                                    style={{ width: '90px' }}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter') {
                                        e.preventDefault();
                                        searchInputRef.current?.focus();
                                      }
                                    }}
                                  />
                                </td>
                                <td>
                                  {formatPrice((item.price || 0) * (item.quantity || 0), false)}
                                </td>
                                <td style={{ width: '40px' }}>
                                  <Button
                                    color="link"
                                    className="p-0 text-danger"
                                    onClick={() => handleRemoveFromCart(item.id)}
                                  >
                                    <FaTrash size={12} />
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="border-top p-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="fs-5 fw-bold text-muted ps-2">
                        {t('cart.total')}
                      </div>
                      <div className="fs-4 fw-bold text-primary pe-2">
                        {formatPrice(totalAmount)}
                      </div>
                    </div>

                    <Button
                      color="success"
                      className="w-100 mt-1 py-2"
                      size="lg"
                      onClick={handleCreateSale}
                    >
                      <FaShoppingCart className="me-2" />
                      {t('buy.confirm')}
                    </Button>
                  </div>
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {/* Receipt Modal */}
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <ModalHeader toggle={() => setModal(false)}>
          {t('receipt.title')}
        </ModalHeader>
        <ModalBody>
          <div
            id="receipt-content"
            className="p-4 bg-white shadow-sm rounded"
            style={{ width: '100%' }}
          >
            {/* Header */}
            <div className="text-center mb-4">
              <h5 className="mb-2">
                <FaStore className="me-2 text-secondary" />
                {company?.name}
              </h5>
              <small className="d-block mb-2">
                <FaMapMarkerAlt className="me-1 text-secondary" />
                {company?.address}
              </small>
              <div className="d-flex justify-content-center align-items-center gap-3">
                {company?.phone && (
                  <small>
                    <FaWhatsapp className="me-1 text-secondary" />
                    {company?.phone}
                  </small>
                )}
                <small>
                  <FaEnvelope className="me-1 text-secondary" />
                  {company?.email}
                </small>
              </div>
            </div>

            <hr />

            {/* Receipt Details */}
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <FaReceipt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.receiptNo')} </span>
                  {receiptData?.numero}
                </div>
                <div>
                  <FaCalendarAlt className="me-2 text-secondary" />
                  <span className="fw-bold">{t('sale.receipt.date')} </span>
                  {receiptData?.createdAt}
                </div>
              </div>
              <div>
                <FaUser className="me-2 text-secondary" />
                <span className="fw-bold">{t('sale.receipt.cashier')} </span>
                {fullName}
              </div>
            </div>

            <hr />

            {/* Products Table */}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>{t('product.description')}</th>
                  <th className="text-end">{t('sale.receipt.price')}</th>
                  <th className="text-end">{t('sale.receipt.quantity')}</th>
                  <th className="text-end">{t('sale.receipt.total')}</th>
                </tr>
              </thead>
              <tbody>
                {receiptData && receiptData.items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.productDescription}</td>
                    <td className="text-end">{formatPrice(item.price)}</td>
                    <td className="text-end">{item.quantity}</td>
                    <td className="text-end">{formatPrice(item.price * item.quantity)}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <hr />

            {/* Totals */}
            <div className="text-end mb-4">
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.subtotal')}</span>
                {formatPrice(receiptData.totalAmountTtc)}
              </div> */}
              {/* <div className="mb-2">
                <span className="fw-bold me-3">{t('sale.receipt.tax')}</span>
                {formatPrice(0)}
              </div> */}


            </div>

            {/* Footer */}
            <div className="text-center mt-4">
              <p className="mb-1">{t('sale.receipt.thankYou')}</p>
              <small className="text-muted">{t('sale.receipt.footer')}</small>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={generatePDF}>
            <FaPrint className="me-1" />
            {t('receipt.printBill')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={clearCartModal} toggle={toggleClearCartModal}>
        <ModalHeader toggle={toggleClearCartModal}>
          {t('cart.clearConfirmTitle')}
        </ModalHeader>
        <ModalBody>
          {t('cart.clearConfirmMessage')}
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleClearCart}>
            {t('cart.confirm')}
          </Button>
          <Button color="secondary" onClick={toggleClearCartModal}>
            {t('cart.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={chooseProductModal} toggle={toggleChooseProductModal} size="xl">
        <ModalHeader toggle={toggleChooseProductModal}>
          {t('product.chooseProduct')}
        </ModalHeader>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <Input
              type="text"
              placeholder={t('product.searchPlaceholder')}
              value={modalSearchTerm}
              onChange={handleModalSearchChange}
              className="me-2" // Added margin to the right
            />
            <Button
              size="sm"
              color="primary"
              onClick={handleProductButtonClick}
            >
              <FaPlus className="me-1" />
              {t('product.new')}
            </Button>
          </div>
          <DisplayToggle />
          {displayMode === 'table' ? <TableView /> : <CardView />}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleChooseProductModal}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={supplierModal} toggle={handleCloseSupplierModal}>
        <ModalHeader toggle={handleCloseSupplierModal}>
          {t('stock.selectSupplier')}
        </ModalHeader>
        <ModalBody>

          {suppliersLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">{t('common.loading')}</span>
              </div>
              <div className="mt-2 text-muted">
                {t('common.loadingData')}
              </div>
            </div>
          ) : (<>
            <div className="d-flex justify-content-between mb-3">
              <Input
                placeholder={t('stock.searchSupplier')}
                value={searchSupplierQuery}
                className={`${isSupplierSearching ? 'searching' : ''}`}
                onChange={e => handleSupplierSearchChange(e)}
              />

              <Button
                color="primary"
                className="ms-2"
                onClick={() => setNewSupplierModal(true)}
              >
                <FaPlus className="me-1" />
                {t('supplier.new')}
              </Button>

            </div>
            <div className="table-responsive">
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>{t('supplier.code')}</th>
                    <th>{t('supplier.description')}</th>
                  </tr>
                </thead>
                <tbody>
                  {!suppliers || suppliers.length === 0 ? (
                    <tr>
                      <td colSpan="6" className="text-center py-4">
                        <div className="text-muted">
                          {t('product.noProducts')}
                        </div>
                      </td>
                    </tr>
                  ) : (suppliers.map((supplier) => (
                    <tr key={supplier.id} onClick={() => handleSupplierSelect(supplier)}>
                      <td>{supplier.code}</td>
                      <td>{supplier.description}</td>
                    </tr>
                  ))
                  )}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <small className="text-muted">
                {t('product.showing', {
                  start: (suppliersPagination.currentPage - 1) * suppliersPagination.pageSize + 1,
                  end: Math.min(suppliersPagination.currentPage * suppliersPagination.pageSize, suppliersTotalElements),
                  total: suppliersTotalElements,
                  currentPage: suppliersPagination.currentPage,
                  totalPages: suppliersTotalPages
                })}
              </small>
              <Pagination size="sm" className="mb-0">
                <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                  <PaginationLink first onClick={() => handleSupplierPageChange(suppliersPagination.currentPage > 0 ? suppliersPagination.currentPage - 1 : 0)}>
                    <FaAngleDoubleLeft size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === 1}>
                  <PaginationLink previous onClick={() => handleSupplierPageChange(suppliersPagination.currentPage > 0 ? suppliersPagination.currentPage - 1 : 0)}>
                    <FaAngleLeft size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                  <PaginationLink next onClick={() => handleSupplierPageChange(suppliersPagination.currentPage + 1)}>
                    <FaAngleRight size={12} />
                  </PaginationLink>
                </PaginationItem>
                <PaginationItem disabled={suppliersPagination.currentPage === suppliersTotalPages}>
                  <PaginationLink last onClick={() => handleSupplierPageChange(suppliersTotalPages)}>
                    <FaAngleDoubleRight size={12} />
                  </PaginationLink>
                </PaginationItem>
              </Pagination>
            </div>
          </>)}
        </ModalBody>
      </Modal>


      <Modal isOpen={newSupplierModal} toggle={() => setNewSupplierModal(false)}>
        <ModalHeader toggle={() => setNewSupplierModal(false)}>
          {t('supplier.new')}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>{t('supplier.description')}</Label>
            <Input
              value={newSupplier.description}
              onChange={e => setNewSupplier({ ...newSupplier, description: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>{t('supplier.contact')}</Label>
            <Input
              value={newSupplier.contact}
              onChange={e => setNewSupplier({ ...newSupplier, contact: e.target.value })}
            />
          </FormGroup>
          <FormGroup>
            <Label>{t('supplier.address')}</Label>
            <Input
              type="textarea"
              value={newSupplier.address}
              onChange={e => setNewSupplier({ ...newSupplier, address: e.target.value })}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleNewSupplierSubmit}>
            {t('common.save')}
          </Button>
          <Button color="secondary" onClick={() => setNewSupplierModal(false)}>
            {t('common.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={productModal} toggle={toggleProductModal} size='lg'>
        <ModalHeader toggle={toggleProductModal}>
          {t('product.createNew')}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="description">{t('product.description')}</Label>
                  <Input
                    id="description"
                    name="description"
                    type="text"
                    required
                    onChange={(e) => e.target.value = e.target.value.toUpperCase()}
                    style={{ textTransform: 'uppercase' }}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="barcode">{t('product.barcode')}</Label>
                  <Input
                    id="barcode"
                    name="barcode"
                    type="text"
                    onChange={async (e) => {
                      const barcode = e.target.value;
                      if (barcode) {
                        let payload = {
                          barcode: barcode,
                          onSuccess: (data) => {
                            Swal.fire({
                              icon: 'warning',
                              title: t('product.duplicateBarcode'),
                              text: t('product.barcodeExistsFor', { product: data.description }),
                              //showCancelButton: true,
                              confirmButtonText: t('common.continue'),
                              //cancelButtonText: t('common.cancel')
                            }).then((result) => {
                              if (result.isConfirmed) {
                                e.target.value = '';
                              }
                            });
                          }
                        };
                        dispatch(productActions.checkBarcode(payload));

                      }
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="userPrice">{t('product.salePrice')}</Label>
                  <Input
                    id="userPrice"
                    name="price"
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="buyingPrice">{t('product.buyingPrice')}</Label>
                  <Input
                    id="buyingPrice"
                    name="buyingPrice"
                    type="number"
                    step="0.01"
                    inputMode="decimal"
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label for="stock">{t('product.stockQty')}</Label>
                  <Input
                    id="stock"
                    name="stock"
                    type="number"
                    required
                    defaultValue={0}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label for="supplier">{t('stock.supplier')}</Label>
                  <div className="d-flex align-items-center">
                    <Input
                      id="supplier"
                      name="supplier"
                      type="text"
                      value={selectedNewSupplier ? selectedNewSupplier.description : ''}
                      disabled
                    />
                    <Button
                      color="secondary"
                      onClick={() => handleOpenSupplierModal('product')}
                      className="ms-2"
                    >
                      <FaSearch />
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <div className="text-end">
              <Button color="secondary" onClick={toggleProductModal} className="me-2">
                {t('common.cancel')}
              </Button>
              <Button color="primary" type="submit">
                {t('common.save')}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      {isModalOpen && (
        <Modal isOpen={isModalOpen} toggle={() => setIsModalOpen(false)} size='lg'>
          <ModalHeader toggle={() => setIsModalOpen(false)}>
            {t('common.searchResults')}
          </ModalHeader>
          <ModalBody >
            <div className="cart-container" style={{
              height: '500px',
              overflowY: 'auto'
            }}>
              <Table bordered hover>
                <thead>
                  <tr>
                    <th></th>
                    <th>{t('inventory.codeArticle')}</th>
                    <th style={{ width: '50%' }}>{t('product.description')}</th>
                    <th>{t('product.buyingPrice')}</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((product) => (
                    <tr key={product.id} style={{ whiteSpace: 'nowrap', height: '20px' }}>
                      <td>
                        <Input
                          type="checkbox"
                          checked={selectedProductIds.includes(product.id)}
                          onChange={(e) => handleCheckboxChange(product.id, e.target.checked)}
                        />
                      </td>
                      <td>{product.barcode}</td>
                      <td>{product.description}</td>
                      <td>{formatPrice(product.buyingPrice)}</td>
                    </tr>
                  ))}
                </tbody>

              </Table>
              <div className="d-flex align-items-center gap-2">
                <Button color="light" size="sm" onClick={() => handlePageChange(1)} disabled={currentPage === 1}>
                  <FaAngleDoubleLeft />
                </Button>
                <Button color="light" size="sm" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                  <FaAngleLeft />
                </Button>

                <span className="mx-2">
                  {currentPage} / {totalPages}
                </span>

                <Button color="light" size="sm" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                  <FaAngleRight />
                </Button>
                <Button color="light" size="sm" onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight />
                </Button>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={handleAddSelectedProducts} disabled={selectedProductIds.length === 0}>
              {t('common.addSelected')}
            </Button>
          </ModalFooter>
        </Modal>
      )}

    </Container >
  );
};

export default BuyForm;
